import { useEffect, useEffectEvent, useState } from 'react';
import { LocalStorageStore } from '../helpers';
import { StoreApi } from '@wyz/types';

type Setter<State> = (arg: State | ((previous: State) => State)) => void;
function usePersistedState<State = string>(
  key: string,
  defaultState: State,
  store: StoreApi<State> = LocalStorageStore,
): [State, Setter<State>] {
  const [state, setState] = useState<State>(store.get(key) ?? defaultState);
  const updateStore = useEffectEvent((state: State) => {
    store.set(key, state);
  });
  useEffect(() => {
    updateStore(state);
  }, [state]);
  return [state, setState];
}

export default usePersistedState;
